import * as z from "zod";
import { merchantSignupFormWithAnalyticsOutputSchema } from "./signup-form-output-schema";

export const getSignupFormById = {
  name: "getSignupFormById" as const,
  input: z.object({ formId: z.string() }),
  output: merchantSignupFormWithAnalyticsOutputSchema,
};
